import { render, staticRenderFns } from "./listJurisd.vue?vue&type=template&id=0621bee8&scoped=true"
import script from "./listJurisd.vue?vue&type=script&lang=js"
export * from "./listJurisd.vue?vue&type=script&lang=js"
import style0 from "./listJurisd.vue?vue&type=style&index=0&id=0621bee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0621bee8",
  null
  
)

export default component.exports